import {
  call, put, all, select,
} from 'redux-saga/effects';
import { apiGetLocals, apiDeleteLocal, apiEditLocal } from 'services/api/locals';

import { getErrorMessage } from 'utils/filters';

import { Creators as LocalsCreators } from '../ducks/locals';
import { Creators as TaskCreators } from '../ducks/task';
import { Creators as AuthCreators, getCompany, getTriiderUser } from '../ducks/auth';
import { Creators as FormCreators } from '../ducks/serviceForm';
import { Creators as UiCreators, growlTypes } from '../ducks/ui';

const fileName = 'sagas/locals';

export function* getLocals({ payload }) {
  try {
    const company = yield select(getCompany);
    const locals = yield call(apiGetLocals, payload, company.id);
    yield put(LocalsCreators.getLocalsSuccess(locals));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(
      UiCreators.growl(message, growlTypes.GROWL_ERROR, { error, method: `${fileName}/getLocals` }),
    );
  }
}

export function* includeLocal({ payload }) {
  try {
    yield put(FormCreators.closeForm());

    yield put(UiCreators.showLoader('FORM_LOCAL'));

    const company = yield select(getCompany);

    // yield call(apiIncludeLocal, payload, company.id);

    const locals = yield call(apiGetLocals, { offset: 0, term: '' }, company.id);
    yield put(LocalsCreators.getLocalsSuccess(locals));

    yield all([
      put(UiCreators.growl('Endereço adicionado!', growlTypes.GROWL_SUCCESS)),
      put(UiCreators.hideLoader('FORM_LOCAL')),
    ]);
  } catch (error) {
    const message = getErrorMessage(error);
    yield all([
      put(
        UiCreators.growl(message, growlTypes.GROWL_ERROR, {
          error,
          method: `${fileName}/includeLocals`,
        }),
      ),
      put(UiCreators.hideLoader('FORM_LOCAL')),
    ]);
  }
}

export function* editLocal({ payload }) {
  try {
    yield put(FormCreators.closeForm());
    yield put(UiCreators.showLoader('FORM_LOCAL'));
    const data = yield call(apiEditLocal, payload);
    if (payload.from_type && payload.from_type === 'Imobiliária' && data.address) {
      yield put(AuthCreators.updateBillingAdress(data.address));
      const newUser = yield select(getTriiderUser);
      yield localStorage.setItem('triiderUser', JSON.stringify(newUser));
    } else {
      yield put(
        LocalsCreators.getLocalsRequest({
          offset: 0,
          term: '',
        }),
      );
      yield put(TaskCreators.editLocalSuccess(data));
    }

    yield all([
      put(UiCreators.growl('Endereço editado com sucesso!', growlTypes.GROWL_SUCCESS)),
      put(UiCreators.hideLoader('FORM_LOCAL')),
    ]);
  } catch (error) {
    const message = getErrorMessage(error);
    yield all([
      put(
        UiCreators.growl(message, growlTypes.GROWL_ERROR, {
          error,
          method: `${fileName}/editLocal`,
        }),
      ),
      put(UiCreators.hideLoader('FORM_LOCAL')),
    ]);
  }
}

export function* deleteLocal({ payload }) {
  try {
    const { success } = yield call(apiDeleteLocal, payload);
    if (success) {
      yield all([
        put(UiCreators.growl('Endereço deletado!', growlTypes.GROWL_SUCCESS)),
        put(LocalsCreators.deleteLocalSuccess({ addressId: payload.id })),
      ]);
    } else {
      throw new Error();
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(
      UiCreators.growl(message, growlTypes.GROWL_ERROR, {
        error,
        method: `${fileName}/deleteLocal`,
      }),
    );
  }
}
